var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "5",
        height: "22",
        viewBox: "0 0 5 22",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", { attrs: { d: "M-9-1h22.167v22.167H-9z" } }),
        _vm._v(" "),
        _c("g", { attrs: { fill: _vm.color } }, [
          _c("path", {
            attrs: {
              d: "M3.759 7.817H.537A.531.531 0 0 0 0 8.342v11.55c0 .29.24.525.537.525h3.222a.531.531 0 0 0\n        .536-.525V8.342c0-.29-.24-.525-.536-.525M3.759.467H.537A.531.531 0 0 0 0 .992v3.15c0 .29.24.525.537.525h3.222a.531.531\n        0 0 0 .536-.525V.992c0-.29-.24-.525-.536-.525",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }